import React, { useState } from 'react';
import './GalleryPage.css';

function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  const images = [
    {
      src: '/images/gallery/IMG_0273.JPG',
      title: 'Team Consultation',
      category: 'team',
      description: 'Our medical team discussing patient care strategies'
    },
    {
      src: '/images/gallery/IMG_1150.JPG',
      title: 'Surgical Preparation',
      category: 'surgery',
      description: 'Preparing for a complex pediatric procedure'
    },
    {
      src: '/images/gallery/IMG_1152.JPG',
      title: 'Patient Care',
      category: 'patients',
      description: 'Post-operative care and recovery'
    },
    {
      src: '/images/gallery/IMG_1158.JPG',
      title: 'Medical Training',
      category: 'team',
      description: 'Training local medical staff'
    },
    {
      src: '/images/gallery/IMG_3425.jpg',
      title: 'Community Outreach',
      category: 'community',
      description: 'Connecting with local communities'
    },
    {
      src: '/images/gallery/IMG_3427.jpg',
      title: 'Hope & Healing',
      category: 'patients',
      description: 'Bringing hope to children and families'
    }
  ];

  const filteredImages = filter === 'all' 
    ? images 
    : images.filter(img => img.category === filter);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  const navigateImage = (direction) => {
    const currentIndex = filteredImages.findIndex(img => img.src === selectedImage.src);
    const newIndex = direction === 'next' 
      ? (currentIndex + 1) % filteredImages.length
      : (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="gallery-hero-background">
          <div className="gallery-gradient-orb orb-1"></div>
          <div className="gallery-gradient-orb orb-2"></div>
        </div>
        <div className="container">
          <div className="gallery-hero-content">
            <span className="gallery-badge">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
              Our Story in Images
            </span>
            <h1 className="gallery-title">Mission Gallery</h1>
            <p className="gallery-description">
              Witness the transformative power of volunteer medical care. 
              Every image tells a story of hope, healing, and humanity.
            </p>
          </div>
        </div>
      </section>

      <section className="gallery-filters">
        <div className="container">
          <div className="filter-buttons">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              <span>All Photos</span>
              <span className="filter-count">{images.length}</span>
            </button>
            <button 
              className={`filter-btn ${filter === 'team' ? 'active' : ''}`}
              onClick={() => setFilter('team')}
            >
              <span>Team</span>
              <span className="filter-count">{images.filter(img => img.category === 'team').length}</span>
            </button>
            <button 
              className={`filter-btn ${filter === 'surgery' ? 'active' : ''}`}
              onClick={() => setFilter('surgery')}
            >
              <span>Surgery</span>
              <span className="filter-count">{images.filter(img => img.category === 'surgery').length}</span>
            </button>
            <button 
              className={`filter-btn ${filter === 'patients' ? 'active' : ''}`}
              onClick={() => setFilter('patients')}
            >
              <span>Patients</span>
              <span className="filter-count">{images.filter(img => img.category === 'patients').length}</span>
            </button>
            <button 
              className={`filter-btn ${filter === 'community' ? 'active' : ''}`}
              onClick={() => setFilter('community')}
            >
              <span>Community</span>
              <span className="filter-count">{images.filter(img => img.category === 'community').length}</span>
            </button>
          </div>
        </div>
      </section>

      <section className="gallery-grid-section">
        <div className="container">
          <div className="gallery-grid">
            {filteredImages.map((image, index) => (
              <div 
                key={index} 
                className="gallery-item"
                onClick={() => openLightbox(image)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="gallery-item-inner">
                  <img src={image.src} alt={image.title} />
                  <div className="gallery-item-overlay">
                    <div className="gallery-item-content">
                      <h3>{image.title}</h3>
                      <p>{image.description}</p>
                      <div className="gallery-item-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="11" cy="11" r="8"/>
                          <path d="M21 21l-4.35-4.35"/>
                          <line x1="11" y1="8" x2="11" y2="14"/>
                          <line x1="8" y1="11" x2="14" y2="11"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          <button 
            className="lightbox-nav prev" 
            onClick={(e) => { e.stopPropagation(); navigateImage('prev'); }}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>

          <button 
            className="lightbox-nav next" 
            onClick={(e) => { e.stopPropagation(); navigateImage('next'); }}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.title} />
            <div className="lightbox-info">
              <h2>{selectedImage.title}</h2>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GalleryPage;

